<template>
  <span :class="`${styleClass} fa-fw ${name} ${colorClass}`"></span>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: "primary",
    },
    style: {
      type: String,
      required: false,
      default: "solid",
      validator: (value) => ["solid", "regular", "brands"].includes(value),
    },
  },
  computed: {
    styleClass: function () {
      return `fa-${this.style}`;
    },
    colorClass: function () {
      if (!this.color || this.color == "inherit") {
        return "";
      }

      return `text-${this.color}`;
    },
  },
};
</script>
